<!-- @migration-task Error while migrating Svelte code: Expected a `#` character immediately following the opening bracket -->
<script>
    // -- IMPORTS
    
	import AddCardBlock from './../../../../../ADMIN/src/lib/component/element/addCardBlock.svelte';
    import CardImageAndTitle from "../blocks/CardImageAndTitle.svelte";
    import TextAndImage from "../blocks/TextAndImage.svelte";
    import TextBlock from "../blocks/TextBlock.svelte";
    import { onMount } from "svelte";
    import TextAndImageVertical from "../blocks/TextAndImageVertical.svelte";
    import Modal from "./Modal.svelte";
    import BlockManager from "../../../../../ADMIN/src/lib/component/element/BlockManager.svelte";
    import AdminEditButton from "./AdminEditButton.svelte";
    import { enabledAdminView } from "$src/lib/store/adminStore";
    import { getLocalizedText } from "senselogic-gist";
    import { languageTagStore } from "$src/lib/store/languageTagStore";
    import ImageBlock from "../blocks/ImageBlock.svelte";
    import ListBlock from "../blocks/ListBlock.svelte";
    import AdminSortableBlocks from "./AdminSortableBlocks.svelte";

    /**
     * @typedef {Object} Props
     * @property {any} [blockArray] - -- VARIABLES
     * @property {string} [pageId]
     */

    /** @type {Props} */
    let { blockArray = [], pageId = "" } = $props();

    let blockGroupArrayBySlug = $state([]);
    let isEditBlockModalOpen = $state(false);
    let blockBeingEdited = $state({});
    let isAddNewBlockToGroupModalOpen = $state(false);

    let initialBlockBeingAdded = $state(
        {
            id : '',
            slug : 'new',
            typeSlug : 'card-group',
            sectionPositionNumber: 0,
            number : 0,
            title : null,
            text : null,
            textArray: [],
            mediaPath : null,
            mediaPathArray : [],
            imageFit : null,
            imageHorizontalPosition : null,
            imageVerticalPosition : null,
            imageSide: 'right',
            pageId: pageId
        }
    );

    // -- FUNCTIONS

    function dispatchOnEditEvent(
        )
    {
        let event = new CustomEvent(
            'on-edit-block',
            {
                bubbles: true
            }
        )

        document.dispatchEvent(event);
    }

    // ~~

    function sortBlockGroup( 
        blockArray 
        )
    {
        blockArray = blockArray.sort( ( a, b ) => a.number - b.number );                       
    }

    // ~~ 

    function separateBlockGroupArrayBySlug(
        )
    {
        blockGroupArrayBySlug = 
            blockArray.reduce(
                ( accumulator, item ) => 
                {
                    if ( !accumulator[ item.slug ] ) 
                    {
                        accumulator[ item.slug ] = [];
                    }

                    accumulator[ item.slug ].push( item );
                    sortBlockGroup( accumulator[ item.slug ] )

                    return accumulator;
                }, 
                {}
            );
    }

    // ~~

    function isFirstOfType(
        slug,
        index
        )
    {
        return blockArray
                    .findIndex( block => block.typeSlug === "card-group" 
                                && block.slug === slug ) === index 
    }

    // ~~
    
    async function saveBlockData(
        )
    {
        isEditBlockModalOpen = false;
        blockBeingEdited = {};
        dispatchOnEditEvent();
    }
    // ~~

    function handleOpenBlockModal(
        block
        )
    {
        isEditBlockModalOpen = true;
        blockBeingEdited = block;
    }

    // ~~

    function handleOpenAddBlockToGroupModal(
        groupSlug,
        groupNumber,
        actualLength,
        pageId
        )
    {
        isAddNewBlockToGroupModalOpen = true;
        initialBlockBeingAdded.slug = groupSlug;
        initialBlockBeingAdded.number = groupNumber;
        initialBlockBeingAdded.sectionPositionNumber = actualLength + 1;
    }

    function handleDeleteBlock(
        blockId,
        slug
        )
    {
        if( slug !== undefined &&
            blockGroupArrayBySlug[ slug ] )
        {
            blockGroupArrayBySlug[ slug ] = blockGroupArrayBySlug[ slug ].filter(( block ) => block.id !== blockId)
        }
        else
        {
            blockArray = blockArray.filter(( block ) => block.id !== blockId)
        }
    }

    // ~~

    function shouldHideBlock(
        block,
        blockIndex = 0
        )
    {
        if( block.typeSlug === "card-group" 
            && !isFirstOfType( block.slug, blockIndex ) )
        {
            return true;
        }

        if( block.typeSlug === "disabled" )
        {
            return true
        }

        return false
    }

    // ~~

    function sortBlockGroupArray(
        event
        )
    {
        let sortedGroupArray = event.detail.blockGroupArray;
        let groupNumber = sortedGroupArray[ 0 ].number;

        blockArray =
            [
                ...blockArray.filter( block => block.number !== groupNumber ),
                ...sortedGroupArray
            ]
            .sort( ( a, b ) => a.number - b.number )

        blockArray = [ ...blockArray ]

        separateBlockGroupArrayBySlug()
    }

    // -- STATEMENTS
    
    onMount(
        () => 
        {
            separateBlockGroupArrayBySlug()

            document.addEventListener( 'on-sort-block-group', sortBlockGroupArray );

            return () => {
                window.removeEventListener( 'on-sort-block-group', sortBlockGroupArray );
            }
        }
    );

</script>

<style lang="stylus">
    // -- IMPORTS

    @import "../../../constant.styl";
    @import "../../../mixin.styl";

    // -- CLASSES

    .render-block-container
    {
        width: 100%;
        margin: 0rem 0;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        & > *
        {
            margin-bottom: 0rem;
        }

        +media( desktop )
        {
            margin: 0;
            border: none;
            padding-bottom: 0;
        }
    }

    .blocks-container
    {
        margin-top: 5rem;
        width: 100%;

        &:last-child
        {
            margin-top: 5rem;
            margin-bottom: 5rem;
        }
    }

    .card-list
    {
        max-width: 100vw;
        height: max-content;
        padding: 0 1rem;

        display: grid;
        gap: 1rem;

        +media( desktop )
        {
            padding: 0 2rem;
            gap: 1.75rem;
            grid-auto-flow: column;
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        }
    }

    .add-card-button
    {
        border: 1px solid lightGoldColor;
        border-radius: 4px;
        padding: 0.75rem 1.25rem;

        display: flex;
        gap: 1rem;
        justify-content: center;
        align-items: center;

        background-color: darkGreyColor;

        font-size: 1rem;
        text-transform: uppercase;
        color: lightGoldColor;

        cursor: pointer;
        text-wrap: nowrap;
        width: 80%;

        transition: all 0.2s ease-in-out;
    }

    .add-card-button:hover,
    .add-card-button:focus
    {
        background-color: lightGoldColor;

        color: darkGreyColor;
    }

    .add-card-button:hover .light-gold-plus-icon
    {
        background-color: darkGreyColor;

        transition: background-color .3s ease-in-out;
    }
</style>

<Modal
    bind:showModal={ isEditBlockModalOpen }
    modalConfirmButtonLabel="Save"
    modalType=""
    hasFooterButtons={ false }
    modalTitle="Edit Block"
>
    <BlockManager
        blockData={ blockBeingEdited }
        selectedLanguageCode={ $languageTagStore }
        onBlockSaved={ saveBlockData }
    />
</Modal>
    
<Modal
    bind:showModal={ isAddNewBlockToGroupModalOpen }
    modalConfirmButtonLabel="Add block"
    modalType=""
    hasFooterButtons={ false }
    modalTitle="Add new block to group"
>
    <AddCardBlock card={ initialBlockBeingAdded } />
</Modal>

<AdminSortableBlocks
    bind:blockArray={ blockArray }
    pageId={ pageId }
/>

<div class="render-block-container" >
    
    {#if blockArray.length > 0}
        {#each blockArray as block, blockIndex } 
            {#if !shouldHideBlock( block, blockIndex )}
                <div 
                    class="blocks-container"
                    class:is-admin-enabled={ $enabledAdminView }
                >
                    {#if block.typeSlug !== "card-group" && block.typeSlug !== "disabled"}
                        <AdminEditButton
                            handleAdminButton={ () => handleOpenBlockModal( block ) }
                            title={ getLocalizedText( block.title || "", $languageTagStore ) }
                            blockId={ block.id }
                            blockMediaPath={ block.mediaPath }
                            onDelete={ handleDeleteBlock }
                        />
                    {/if }

                    {#if block.typeSlug === "media-and-text" || block.typeSlug === "text-and-media"}
                        <TextAndImage 
                            block={ block }
                        />
        
                    {:else if block.typeSlug === "media-and-text-vertical" || block.typeSlug === "text-and-media-vertical"}
                        <TextAndImageVertical 
                            block={ block }
                        />
        
                    {:else if block.typeSlug === "card-group"}
                        {#if blockGroupArrayBySlug[ block.slug ] && isFirstOfType( block.slug, blockIndex )}
                            <div class="card-list">
                                {#each blockGroupArrayBySlug[ block.slug ] as cardBlock, cardBlockIndex}
                                    {#if cardBlock.typeSlug === "card-group"}
                                        <CardImageAndTitle 
                                            block={ cardBlock } 
                                            blockIndex={ cardBlockIndex } 
                                            onDeleteBlock={ handleDeleteBlock }
                                        />
                                    {/if }
                                {/each}

                                {#if blockGroupArrayBySlug[ block.slug ].length < 5 && $enabledAdminView}
                                    <button class="add-card-button" onclick={ () => handleOpenAddBlockToGroupModal( block.slug, block.number, blockGroupArrayBySlug[ block.slug ].length ) }>
                                        <div class="light-gold-plus-icon size-150"></div>

                                        <p>Add new card</p>
                                    </button>
                                {/if}
                            </div>
        
                        {/if}
                    {:else if block.typeSlug === "text"}
                        <TextBlock block={ block } />
        
                    {:else if block.typeSlug === "media"}
                        <ImageBlock block={ block } />
        
                    {:else if block.typeSlug === 'list'}
                        <ListBlock block={ block } />
                    {/if}
                </div>
            {/if}
        {/each}
    {/if}
</div>